var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card-code',[_c('b-row',[(_vm.userData.role == 'channelpartner')?_c('b-col',{attrs:{"md":"9"}},[_c('ecommerce-statistics',{attrs:{"data":_vm.statisticsItems,"cp":true}})],1):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }